import React, {Fragment} from 'react';
import classes from './AddEligibilityConfirmation.css';
import Label from '../../UI/Label2/Label2';
import Button from '../../UI/Button/Button';
import { LABEL_SAVE, ELIGIBILITY_CONFIRMATION, MEDICAL_RECORD_NUMBER } from '../../shared/Constants';
import { getPortalNameForEligibilityScreen } from '../../shared/utility';

const addEligibilityConfirmation = (props) => {

    let form = null;

    const isSdkPortal = props.selectedPortal.isSdkPortal || props.selectedPortal.isPePortal;

    if(props.memberInfo && props.selectedPortal && props.updatedFormData) {

        const memberMdmInfo = (
            <div>
                <strong className={classes.Caution}>You're about to modify or add an eligibility record for this member:</strong>
                <br/>
                <Label displayType="horizontal" labelText="Name" labelValue={props.memberInfo.mdmFirstNm+" "+props.memberInfo.mdmLastNm} labelWidth="15%" />
                <Label displayType="horizontal" labelText="DOB" labelValue={props.memberInfo.mdmDob} labelWidth="15%" />
                <Label displayType="horizontal" labelText="Zip" labelValue={props.memberInfo.mdmZip} labelWidth="15%" />
                <strong className={classes.Caution}>Are you sure?</strong>
            </div>);

        let addPortalEligElems=[];
        if(!isSdkPortal){
            for (let key in ELIGIBILITY_CONFIRMATION.displayPropMapping) {
                let displayValue;
                if(!isSdkPortal && props.selectedPortal?.validElems[key] && props.selectedPortal?.validElems[key]?.isEnabled) {
                    displayValue = props.updatedFormData[key];
                    if((props.updatedFormData['targetPortal'] === 'MYUHC' || props.updatedFormData['targetPortal'] === 'BSCA' || props.updatedFormData['targetPortal'] === 'HARVARDPILGRIM' || props.updatedFormData['targetPortal'] === 'MORGANWHITE') && key === 'MemberId'){
                        displayValue = props.updatedFormData['SubscriberId']
                    }
                    addPortalEligElems.push(
                        <Label
                            key={"new"+ELIGIBILITY_CONFIRMATION.displayPropMapping[key].label}
                            displayType="horizontal"
                            labelText={ELIGIBILITY_CONFIRMATION.displayPropMapping[key].label}
                            labelValue={displayValue}
                            labelWidth="40%"/>
                    );
                }
            }
        }else{
            let displayValue;
            for (let key in props.updatedFormData) {
                if(ELIGIBILITY_CONFIRMATION.sdkDisplayPropMapping[key])
                {
                    displayValue = props.updatedFormData[key];
                    addPortalEligElems.push(
                        <Label
                            key={"new"+ELIGIBILITY_CONFIRMATION.sdkDisplayPropMapping[key].label}
                            displayType="horizontal"
                            labelText={props.selectedPortal.portalShortName === 'ECONSENTLOOP' && key === 'memberId'? MEDICAL_RECORD_NUMBER : ELIGIBILITY_CONFIRMATION.sdkDisplayPropMapping[key].label}
                            labelValue={displayValue}
                            labelWidth="40%"/>
                    );
                }
            }
        }

        if(props.selectedPortal.portalShortName === 'BSCA' || props.selectedPortal.portalShortName === 'HARVARDPILGRIM' || props.selectedPortal.portalShortName === 'MORGANWHITE'){
            addPortalEligElems.push(
                <Label
                    key="Group/Policy ID"
                    displayType="horizontal"
                    labelText="Group/Policy ID"
                    labelValue={props.memberGroupID}
                    labelWidth="40%"/>
            );
        }

        const addPortalElig = (
            <div className={classes.Section}>
                <strong className={classes.SectionTitle}>{getPortalNameForEligibilityScreen(props.selectedPortal.portalShortName, props.portals)} Add Eligibility Portal Details</strong>
                {addPortalEligElems}
            </div>
        );

        const buttons = (
            <div className={classes.ButtonDiv}>
                <Button id="cancel" btnType="Cancel" clicked={props.cancelled}>Cancel</Button>
                <Button id="save" btnType="AddAccountSearch" clicked={() => props.addEligibility(props.updatedFormData)}>{LABEL_SAVE}</Button>
            </div>
        );

        form = 
            <Fragment>
                {memberMdmInfo}
                <br/>
                <div className={classes.EligSection}>
                    {addPortalElig}
                </div>
                <br/>
                {buttons}
            </Fragment>
    }

    return form;
}

export default addEligibilityConfirmation;